export function initHeaderScroll() {
    const header = document.querySelector( '.site-header' );
    if ( ! header ) return;

    let prevY   = window.scrollY;
    let anchorY = window.scrollY;

    window.addEventListener( 'scroll', () => {
        const y     = window.scrollY;
        const delta = y - prevY;
        prevY = y;

        if ( y < 50 ) {
            header.classList.remove( 'site-header--compact' );
            anchorY = y;
            return;
        }

        const isCompact = header.classList.contains( 'site-header--compact' );

        if ( ! isCompact && delta > 0 ) {
            if ( y - anchorY >= 100 ) {
                header.classList.add( 'site-header--compact' );
                anchorY = y;
            }
        } else if ( isCompact ) {
            if ( delta > 0 ) {
                anchorY = y;
            } else if ( delta < 0 && anchorY - y >= 100 ) {
                header.classList.remove( 'site-header--compact' );
                anchorY = y;
            }
        }
    }, { passive: true } );
}
